import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'roboto-fontface/css/roboto/roboto-fontface.css'

// Icons
import HomeIcon from "@/icons/HomeIcon.vue";
import MessageIcon from "@/icons/MessageIcon.vue";
import BoxIcon from "@/icons/BoxIcon.vue";
import ReportIcon from "@/icons/ReportIcon.vue";
import LocationIcon from "@/icons/LocationIcon.vue";
import LocationsIcon from "@/icons/LocationsIcon.vue";
import FitToPageIcon from "@/icons/FitToPageIcon.vue";
import CalendarIcon from "@/icons/CalendarIcon.vue";
import UserIcon from "@/icons/UserIcon.vue";
import SettingsIcon from "@/icons/SettingsIcon.vue";
import DashboardIcon from "@/icons/DashboardIcon.vue";
import InventarioIcon from "@/icons/InventarioIcon.vue";
import CampaignsIcon from "@/icons/CampaignsIcon.vue";
import FilterIcon from "@/icons/FilterIcon.vue";
import OpenboxIcon from "@/icons/OpenboxIcon.vue";
import ArrowRightIcon from "@/icons/ArrowRightIcon.vue";
import LedscreenIcon from "@/icons/LedscreenIcon.vue";
import TicketIcon from "@/icons/TicketIcon.vue";
import ChipIcon from "@/icons/ChipIcon.vue";
import MupiIcon from "@/icons/MupiIcon.vue";
import OperationsIcon from "@/icons/OperationsIcon.vue";
import ColganteIcon from "@/icons/ColganteIcon.vue";
import EspectacularesIcon from "@/icons/EspectacularesIcon.vue";
import Luminoso2cIcon from "@/icons/Luminoso2cIcon.vue";
import LuminosoIcon from "@/icons/LuminosoIcon.vue";
import Mupi2cIcon from "@/icons/Mupi2cIcon.vue";
import ProjectorIcon from "@/icons/ProjectorIcon.vue";
import EventosIcon from "@/icons/EventosIcon.vue";
import VallasIcon from "@/icons/VallasIcon.vue";
import VideowallIcon from "@/icons/VideowallIcon.vue";

import { mdiMapMarkerMultipleOutline } from '@mdi/js';
import { mdiFitToPageOutline } from '@mdi/js';
Vue.use(Vuetify)

export default new Vuetify({
  iconFont: "mdi",
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: "#679940",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        navbar: "#2A2F34",
        navbar2: "#41474A",
        navbar3: "#689940",
        navbar4: "#7BA556",
        drawer: "#F5F5F5",
        activebtn: "#707070",
        white: "#fff",
        // colores Admira
        admiraGreen: "#689840",
        admiraBtn: "#749948",
        admiraLightGray:'#F5F5F5',
        admiraFontGray: '#777777',
        admiraGreenInputHeader: "#7BA556",
        //statusColors:
        statusGreen: "#689840",
        statusRed: "#fd846d",
        statusOrange: "#f6ae2d", 
        statusGray: "#acacac",
        //colores code sites
        avatarA:"#86BBD8",
        avatarCC:"#6CB192",
        avatarV:"#B16C8B", 
      }
    },
  },
  icons: {
    values: {
      home: {component: HomeIcon},
      message: {component: MessageIcon},
      box: {component: BoxIcon},
      report: {component: ReportIcon},
      location: {component: LocationIcon},
      locations: {component: LocationsIcon},
      fitToPage: {component: FitToPageIcon},
      calendar: {component: CalendarIcon},
      user: {component: UserIcon},
      settings: {component: SettingsIcon},
      dashboard: {component: DashboardIcon},
      inventario: {component: InventarioIcon},
      campaigns: {component: CampaignsIcon},
      filter: {component: FilterIcon},
      openbox: {component: OpenboxIcon},
      arrowRight: {component: ArrowRightIcon},
      ledscreen: {component: LedscreenIcon},
      ticket: {component: TicketIcon},
      chip: {component: ChipIcon},
      mupi: {component: MupiIcon},
      operations: {component: OperationsIcon},
      colgante: {component: ColganteIcon},
      espectaculares: {component: EspectacularesIcon},
      luminoso2c: {component: Luminoso2cIcon},
      luminoso: {component: LuminosoIcon},
      mupi2c: {component: Mupi2cIcon},
      projector: {component: ProjectorIcon},
      eventos: {component: EventosIcon},
      vallas: {component: VallasIcon},
      videowall: {component: VideowallIcon},
    }
  }
});



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js